// extracted by mini-css-extract-plugin
module.exports = {"ErrorMessage":"RegisterForm_ErrorMessage__1tRzd"};